<template>
  <div class="mainBackground">
    <header-bar :type="type"></header-bar>
    <div class="main-box" :class="{ 'min-box': step == 1 }">
      <h-steps v-if="step == 0 || step == 1" :current="step">
        <h-step title="验证账号"></h-step>
        <h-step title="重置密码"></h-step>
        <h-step title="完成修改"></h-step>
      </h-steps>
      <!-- 验证账号 -->
      <div class="main" v-if="step == 0" key="1">
        <h-form
          ref="form"
          class="form"
          :model="formData"
          :rules="formRules"
          :label-width="60"
        >
          <h-form-item label="账号" prop="login_name">
            <h-input
              class="login-input"
              v-model="formData.login_name"
              placeholder="请输入你需要找回登录密码的账户名"
              autocomplete="off"
            ></h-input>
          </h-form-item>
          <h-form-item label="验证码">
            <h-input
              class="login-input"
              v-model="formData.captcha_img_code"
              placeholder="请输入图形验证码"
            ></h-input>
            <img
              class="image-code"
              :src="imageCode.captcha_img_base64"
              @click="getCheckCode"
            />
            <div class="changeImageCode" @click="getCheckCode">
              看不清换一张
            </div>
          </h-form-item>
          <h-form-item>
            <h-button class="confirm-button" @click="confirmClick(step)"
              >确 认</h-button
            >
          </h-form-item>
        </h-form>
      </div>
      <!-- 重置密码 -->
      <div class="reset" v-if="step == 1" key="2">
        <h-form
          ref="form"
          class="form"
          :model="formData"
          :rules="formRules"
          :label-width="90"
        >
          <h-form-item label="账号" prop="login_name">
            <div class="phone-box">
              <span v-show="!phoneShow">{{ formData.login_name }}</span>
              <h-input
                v-show="phoneShow"
                class="login-input"
                v-model="formData.login_name"
                placeholder="请输入账号"
                @on-blur="phoneShow = false"
                autocomplete="off"
              ></h-input>
              <i
                class="iconfont iconbianji my-icon"
                @click="phoneShow = !phoneShow"
              ></i>
            </div>
          </h-form-item>
          <h-form-item v-if="imageCodeShow" label="图形验证码">
            <h-input
              class="login-input"
              v-model="formData.captcha_img_code"
              placeholder="请输入图形验证码"
            >
            </h-input>
            <img
              class="image-code"
              :src="imageCode.captcha_img_base64"
              @click="getCheckCode"
            />
            <i @click="getCheckCode" class="iconfont iconshuaxin my-icon"></i>
          </h-form-item>
          <h-form-item label="验证码" prop="captcha_sms_code">
            <h-input
              class="login-input"
              v-model="formData.captcha_sms_code"
              placeholder="请输入验证码"
              autocomplete="off"
            ></h-input>
            <div
              @click="getSmsCheckCode"
              class="message-div"
              :class="{
                'secondes-message':
                  checkCodeActive && !resendShow && formData.login_name
              }"
            >
              {{ !resendShow ? "获取验证码" : `${seconds}秒后可重发` }}
            </div>
          </h-form-item>
          <h-form-item prop="login_password" label="输入新密码" class="psd">
            <div class="login-box">
              <h-input
                v-show="!passwordSee"
                type="password"
                class="login-input"
                v-model="formData.login_password"
                placeholder="请输入新密码"
                autocomplete="new-password"
              ></h-input>
              <h-input
                v-show="passwordSee"
                class="login-input"
                v-model="formData.login_password"
                placeholder="请输入新密码"
                autocomplete="new-password"
              ></h-input>
              <img
                v-show="!passwordSee"
                class="see-open"
                @click="passwordSee = true"
                src="~@/assets/login/eyeOpen.png"
              />
              <img
                v-show="passwordSee"
                class="see-close"
                @click="passwordSee = false"
                src="~@/assets/login/eyeClose.png"
              />
              <i v-if="iconShow" class="iconfont iconxuanzhong my-icon"></i>
              <!-- <span class="iconfont icon-success my-icon"></span> -->
            </div>
            <div class="psd-strong">
              <p>
                长度为8-20字符，包含数字、大小写字母，建议添加特殊符<br />号，会显著提高密码安全性
              </p>
              <ul>
                <li :class="{ 'low-active': strong === 1 }">弱</li>
                <li :class="{ 'middle-active': strong === 2 }">中</li>
                <li :class="{ 'hight-active': strong === 3 }">强</li>
              </ul>
            </div>
          </h-form-item>
          <h-form-item label="确认新密码" prop="login_password_confirm">
            <h-input
              v-show="!passwordConfirmSee"
              type="password"
              class="login-input"
              v-model="formData.login_password_confirm"
              placeholder="请在此输入密码"
            ></h-input>
            <h-input
              v-show="passwordConfirmSee"
              class="login-input"
              v-model="formData.login_password_confirm"
              placeholder="请在此输入密码"
            ></h-input>
            <img
              v-show="!passwordConfirmSee"
              class="see-open"
              @click="passwordConfirmSee = true"
              src="~@/assets/login/eyeOpen.png"
            />
            <img
              v-show="passwordConfirmSee"
              class="see-close"
              @click="passwordConfirmSee = false"
              src="~@/assets/login/eyeClose.png"
            />
            <i v-if="confirmShow" class="iconfont iconxuanzhong my-icon"></i>
          </h-form-item>
          <h-form-item>
            <h-button class="confirm-button" @click="confirmClick(step)"
              >确 认</h-button
            >
          </h-form-item>
        </h-form>
        <!-- <h-form
        ref="formCustom"
        :model="formCustom"
        :rules="ruleCustom"
        :label-width="80"
      >
        <h-form-item label="密码" prop="passwd">
          <h-input type="password" v-model="formCustom.passwd"></h-input>
        </h-form-item>
        <h-form-item>
          <h-button type="primary" @click="handleSubmit('formCustom')"
            >提交</h-button
          >
          <h-button
            type="ghost"
            @click="handleReset('formCustom')"
            style="margin-left: 8px"
            >重置</h-button
          >
        </h-form-item>
      </h-form> -->
      </div>
      <!-- 完成修改 -->
      <div class="complete" v-if="step == 2">
        <img src="~@/assets/login/complete.jpg" class="complete-img" />
        <p>恭喜！密码修改成功</p>
        <span>{{ sd }}s后将跳转回登录页面</span>
      </div>
    </div>
    <glob-footer></glob-footer>
  </div>
</template>

<script>
import HeaderBar from "@/views/frontViews/components/headerBar";
import GlobFooter from "@/views/frontViews/components/globFooter";
import {
  CheckCode,
  smsCheckCode,
  validateAccount,
  resetPassword
} from "@/api/login.js";
import { queryParams, getUrlParam } from "@/utils";
export default {
  data() {
    //登录名验证
    const phoneOrEmailRule = (rule, value, callback) => {
      if (value) {
        if (
          !/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value) &&
          !/^1[0-9]{10}$/.test(value)
        ) {
          this.checkCodeActive = false;
          // 不合法
          return callback(new Error("请输入正确的手机号码或邮箱"));
        }
      }
      this.checkCodeActive = true;
      return callback();
    };
    //验证短信验证码
    const checkCodeRule = (rule, value, callback) => {
      if (value) {
        if (value.length < 4) {
          return callback(new Error("最短不能少于4位字符"));
        }
      }
      return callback();
    };
    //确认密码验证
    const confirmRule = (rule, value, callback) => {
      if (value) {
        if (this.formData.login_password !== value) {
          this.confirmShow = false;
          return callback(new Error("两次密码输入不一致"));
        }
      } else {
        this.confirmShow = false;
        return;
      }
      this.confirmShow = true;
      return callback();
    };
    //密码规则验证
    const psdRule = (rule, value, callback) => {
      console.log(value);
      if (!value) console.log(111);
      if (value) {
        if (this.checkPerStrong(value) < 2) {
          this.iconShow = false;
          return callback(new Error("密码过于简单"));
        }
        if (value.length < 8 || value.length > 20) {
          this.iconShow = false;
          return callback(new Error("密码不符合要求"));
        }
      } else {
        this.iconShow = false;
        return;
      }
      this.iconShow = true;
      return callback();
    };
    return {
      /**
       * type: 头部组件复用区分类型
       * step： 忘记密码步骤
       * strong: 密码强度
       * formRules： 表单规则
       * iconShow： 控制新密码第一次符合要求时展示对勾图标
       * confirmShow：控制确认密码与第一次输入密码一致时展示对勾图标
       * passwordSee：是否显示密码
       * passwordConfirmSee： 是否显示确认密码
       * sd：多少秒后将跳转回登录页面
       * imageCode：验证码对象
       * phoneShow：是否显示手机表单项
       * seconds： 60s倒计时
       * resendShow：是否显示xx秒后可重发
       * checkCodeActive: 手机验证是否合法
       */
      type: "forget",
      formData: {
        login_name: "",
        captcha_img_code: "",
        captcha_sms_code: "",
        login_password: "",
        login_password_confirm: ""
      },
      step: 0,
      strong: 0,
      formRules: {
        login_password: [{ validator: psdRule, trigger: "change" }],
        captcha_sms_code: [{ validator: checkCodeRule, trigger: "change" }],
        login_password_confirm: [{ validator: confirmRule, trigger: "change" }],
        login_name: [{ validator: phoneOrEmailRule, trigger: "change" }]
      },
      iconShow: false,
      confirmShow: false,
      passwordSee: false,
      passwordConfirmSee: false,
      sd: 5,
      imageCode: {},
      phoneShow: false,
      seconds: 60,
      resendShow: false,
      checkCodeActive: false,
      imageCodeShow: false
    };
  },
  components: {
    HeaderBar,
    GlobFooter
  },
  computed: {},
  methods: {
    //忘记密码-重置密码
    getResetPassword() {
      if (
        !(
          this.formData.login_name &&
          this.formData.login_name !== "" &&
          this.formData.captcha_sms_code &&
          this.formData.captcha_sms_code !== "" &&
          this.formData.login_password &&
          this.formData.login_password !== "" &&
          this.formData.login_password_confirm &&
          this.formData.login_password_confirm !== ""
        ) ||
        (!(
          this.formData.captcha_img_code != "" && this.formData.captcha_img_code
        ) &&
          this.imageCodeShow)
      ) {
        this.$hMessage.error("请填写完整表单信息");
        return;
      }
      this.$refs["form"].validate(valid => {
        if (valid) {
          resetPassword(this.formData)
            .then(res => {
              if (res.error_code == 0) {
                this.step += 1;
                this.secondLogin();
              } else this.$hMessage.info(res.error_info);
            })
            .catch(error => {});
        } else {
        }
      });
    },
    //获取短信验证码
    getSmsCheckCode() {
      if (!this.checkCodeActive || this.formData.phone === "") {
        // 手机号码不合法
        return;
      }
      if (this.resendShow) {
        // 获取短信验证码次数超显示图形验证码
        return;
      } else {
        var params = { ...this.formData, captcha_sms_type: 4 };
        params = this.imageCodeShow
          ? {
              ...params,
              captcha_img_id: this.imageCode.captcha_img_id
            }
          : params;
        params = queryParams(params);
        smsCheckCode(params)
          .then(res => {
            if (res.error_code == "110004") {
              this.$hMessage.info(res.error_info);
              this.imageCodeShow = true;
              this.getCheckCode();
            } else if (res.error_code == "0") {
              this.tips = "";
              this.resendMessage();
            } else {
              this.$hMessage.info(res.error_info);
              this.getCheckCode();
            }
          })
          .catch(error => {});
      }
    },
    // 60s后重新发送验证码
    resendMessage() {
      this.resendShow = true;
      let timer = null;
      this.seconds = 60;
      timer = setInterval(() => {
        if (this.seconds == 0) {
          this.resendShow = false;
          clearInterval(timer);
          return;
        }
        this.seconds--;
      }, 1000);
    },
    //忘记密码-验证账户
    getValidateAccount() {
      if (
        !(
          this.formData.login_name &&
          this.formData.login_name !== "" &&
          this.formData.captcha_img_code &&
          this.formData.captcha_img_code !== ""
        )
      ) {
        this.$hMessage.error("请填写完整表单信息");
        return;
      }
      this.$refs["form"].validate(valid => {
        if (valid) {
          var params = {
            ...this.formData,
            captcha_img_id: this.imageCode.captcha_img_id
          };
          validateAccount(params)
            .then(res => {
              console.log(res);
              if (res.error_code == "0") {
                this.step += 1;
                this.formData.captcha_img_code = "";
                this.imageCode = {};
              } else {
                this.getCheckCode();
                this.$hMessage.info(res.error_info);
              }
            })
            .catch(error => {});
        } else {
        }
      });
    },

    //获取图形验证码
    getCheckCode() {
      CheckCode()
        .then(res => {
          this.imageCode = res;
          console.log(res, this.imageCode);
        })
        .catch(error => {});
    },
    // 5s后跳转到登录页
    secondLogin() {
      let time = null;
      console.log(1);
      time = setInterval(() => {
        if (this.sd == 0) {
          clearInterval(time);
          let _service = getUrlParam("", "service");
          let _from = getUrlParam("", "from");
          if (_service && _from) {
            window.location.href = decodeURIComponent(_service);
          } else if (_service) {
            this.$router.push("/login?service=" + _service);
          } else {
            this.$router.push("/login");
          }
          return;
        }
        this.sd--;
      }, 1000);
    },
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$Message.success("提交成功!");
        } else {
          this.$Message.error("表单验证失败!");
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    // 设置密码强度
    checkPerStrong(val) {
      var val = val.replace(/\s+/, "");
      var modes = 0;
      this.strong = 0;
      if (/\d/.test(val)) modes++; /* 有数字 */
      if (/[a-z]/.test(val)) modes++; /* 有小写 */
      if (/[A-Z]/.test(val)) modes++; /* 有大写 */
      if (modes === 3) {
        this.strong = 2;
      } else if (modes !== 0) {
        this.strong = 1;
      }
      if (/\W/.test(val)) modes++; /* 有特殊字符 */
      if (modes === 4) {
        this.strong = 3;
      }
      return this.strong;
    },
    //点击确认按钮跳转下一步
    confirmClick(step) {
      console.log(this.step);
      if (this.step === 0) {
        this.getValidateAccount();
        // 重置图形验证码
        // this.formData.captcha_img_code = ""
      } else if (this.step === 1) this.getResetPassword();
    }
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    console.log(this.step);
    this.getCheckCode();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {}
};
</script>
<style lang="scss" scoped>
.phone-box {
  display: inline-block;
  height: 46px;
  line-height: 46px;
  span {
    display: inline-block;
    width: 320px;
    height: 46px;
    padding: 0 16px;
    font-size: 14px;
    line-height: 14px;
  }
  i {
    vertical-align: middle;
  }
}

.my-icon {
  font-size: 24px;
  position: absolute;
  right: -40px;
  top: 50%;
  transform: translate(0, -50%);
}
.iconxuanzhong {
  color: #1cb77b;
}
.iconshuaxin,
.iconbianji {
  cursor: pointer;
}
.mainBackground {
  background: #ffff;
  min-height: 100vh;
  //   height: 800px;
  // .step-bar {
  //   width: 380px;
  //   height: 32px;
  //   margin: 164px auto 0;
  //   .h-steps-item {
  //     width: 170px !important;
  //     &:last-child {
  //       width: 26px !important;
  //     }
  //   }
  // }
  .main-box {
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // position: relative;
    min-height: calc(100vh - 430px);
    // min-height: 516px;
    padding: 56px 0 0;
  }
  // .min-box {
  //   // min-height: 756px;
  // }
  .main {
    width: 1040px;
    height: 330px;
    margin: 0 auto 120px;
    background: #f3f7fe;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    .changeImageCode {
      display: inline-block;
      width: 42px;
      padding: 9px 0;
      height: 42px;
      font-size: 14px;
      line-height: 14px;
      color: #4686f2;
      position: absolute;
      right: -50px;
      color: #4686f2;
      &:hover {
        cursor: pointer;
      }
    }
    .image-code {
      width: 104px;
      height: 46px;
      position: absolute;
      top: 0;
      right: 0;
      border: 1px solid #d9d9d9;
      border-radius: 0 6px 6px 0;
      cursor: pointer;
    }
  }
  // 重置密码
  .reset {
    width: 1040px;
    height: 534px;
    margin: 0 auto 56px;
    background: #f3f7fe;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .image-code {
      width: 104px;
      height: 46px;
      position: absolute;
      top: 0;
      right: 0;
      border: 1px solid #d9d9d9;
      border-radius: 0 6px 6px 0;
      cursor: pointer;
    }
    .see-open,
    .see-close {
      cursor: pointer;
      width: 20px;
      height: 12px;
      position: absolute;
      right: 10px;
      top: 17px;
      z-index: 5;
    }
    .message-div {
      position: absolute;
      top: 0;
      right: 0;
      background: #e2e2e2;
      border: 1px solid #e2e2e2;
      width: 130px;
      height: 46px;
      border-radius: 0 6px 6px 0;
      text-align: center;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #ffffff;
      line-height: 44px;
      cursor: not-allowed;
    }
    .secondes-message {
      background: #3060ff;
      border: 1px solid #3060ff;
      cursor: pointer;
    }
    .psd-strong {
      p {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        line-height: 16px;
        margin: 8px 0;
      }
      ul {
        display: flex;
        flex-direction: row;
        li {
          width: 60px;
          height: 20px;
          background: #e6e6e6;
          margin-right: 10px;
          border-radius: 2px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
          text-align: center;
        }
        .low-active {
          background: #ff3030;
        }
        .middle-active {
          background: #ff791a;
        }
        .hight-active {
          background: #3060ff;
        }
      }
    }
  }
  .complete {
    margin: 128px 0 256px;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .complete-img {
      width: 200px;
      height: 100px;
    }
    p {
      padding: 38px 0 8px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      text-align: center;
      line-height: 20px;
    }
    span {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      line-height: 14px;
    }
  }
}
</style>
<style lang="scss">
.main,
.reset {
  .h-form-item {
    margin-bottom: 16px;
  }
  .is-save {
    height: 20px;
  }
  .login-box {
    position: relative;
  }
  .login-input {
    width: 320px;
    height: 46px;
    .h-input {
      width: 320px;
      height: 46px;
      padding: 4px 16px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #9b9b9b;
      border-radius: 6px;
    }
  }
  .confirm-button {
    width: 320px;
    height: 46px;
    background: #3060ff;
    margin-top: 24px;
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 18px;
  }
  .form {
    margin: auto;
    .h-form-item-content {
      line-height: 24px;
    }
    .h-form-item .h-form-item-label {
      width: 60px;
      height: 46px;
      line-height: 46px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #333333;
    }
    .psd {
      .h-form-item-content .verify-tip.verify-bottom {
        position: absolute;
        top: -74px;
      }
    }
  }
}
.mainBackground {
  .h-steps {
    width: 380px;
    padding-bottom: 40px;
    margin: 64px auto 0;
    .h-steps-item {
      width: 170px !important;
      &:last-child {
        width: 26px !important;
      }
      .h-steps-head {
        padding: 0 12px;
      }
      .h-steps-main {
        width: 66px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/components/forgetPassword.vue